import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Card, Modal, Form, Button } from 'react-bootstrap';
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import './UserProfilePage.css';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { formatPhoneNumber } from "../../utils/formatPhone";
import moment from "moment";

export default function ViewDoctor() {

    const { t } = useContext(TranslatorContext)
    const { doctor_id } = useParams();
    const [Data, setData] = useState('');
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [about, setabout] = useState('');
    const [content, setContent] = useState(0);

    const [appointment, setappointment] = useState([]);
    const [consultation, setconsultation] = useState([]);
    const [Review, setReview] = useState([]);
    const contentTypes = {
        appointment: 0,
        consultation: 1,
        ratings: 2
    };
    const handleButtonClick = (contentType) => {
        setContent(contentTypes[contentType]);
    };

    const getData = () => {
        axios.post(API_URL + '/get_doctor_By_Id', { doctor_id }).then((res) => {
            setData(res.data.doctor_arr[0]);
            setabout(res.data.doctor_arr[0].about_doctor)
            setappointment(res.data.doctor_arr[0].fetchAppointmentArr);
            setconsultation(res.data.doctor_arr[0].fetchConsultation_arr);


        }).catch((error) => {
            console.log(error);

        })

    }

    const fetchRatings = () => {
        axios.post(API_URL + '/fetch_rating', { type: 2, doctor_id }).then((response) => {
            setReview(response.data.rating_arr);
            console.log(response.data.rating_arr);
        }).catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        getData();
        fetchRatings();
    }, [])
    const handleImageClick = (imageUrl) => {
        setEnlargedImage(imageUrl);
        setShowImagePopup(true);
    };
    const handleCloseImage = () => {
        setEnlargedImage(null);
        setShowImagePopup(false);
    };

    return (
        <PageLayout>
            <Col xl={12}>
                <div className="mc-card">
                    <div className='mc-breadcrumb'>
                        <h3 className="mc-breadcrumb-title">{t('doctor_profile')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/manage-doctors'}`} className="mc-breadcrumb-link">{t('manage_doctors')}</Link></li>
                            <li className="mc-breadcrumb-item">{t('doctor_profile')}</li>
                        </ul>
                    </div>
                </div>
            </Col>
            <div className="mc-card p-lg-4">
                <Row>
                    <Col xl={4}>
                        <h6 className="mc-divide-title mb-4">{t('doctor_profile')}</h6>
                        <div className="mc-user-group">
                            <div className="">
                                <div className="">

                                    <img
                                        src={Data.image ? `${Data.image}` : `image-1720095670109.png`}
                                        alt="Profile"
                                        style={{ width: '15rem', height: '15rem', borderRadius: '5%', cursor: 'pointer' }}
                                        onClick={() => handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`);
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    />

                                    {/* Enlarged image overlay */}
                                    {showImagePopup && (
                                        <div
                                            className="enlarged-image-overlay"
                                            onClick={handleCloseImage}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Escape') {
                                                    handleCloseImage();
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <span
                                                className="close-button"
                                                onClick={handleCloseImage}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleCloseImage();
                                                    }
                                                }}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                &times;
                                            </span>
                                            <img src={enlargedImage} alt="Enlarged Profile" className="enlarged-image" style={{ width: '30rem', height: '30rem' }} />
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </Col>
                    <Col xl={8}>
                        <h6 className="mc-divide-title mb-4">{t('doctor_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('doctor_name')} : &nbsp;
                                            </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>{Data.doctor_name}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('email')} : &nbsp;
                                            </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>{Data.email}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('mobile')} : &nbsp;
                                            </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.mobile)}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('clinic_name')} : &nbsp;
                                            </h6>

                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>{Data.clinic_name}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2"> {t('service_name')} : &nbsp;  </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400', wordSpacing: '5px' }}>
                                                {typeof Data.service_name === 'string'
                                                    ? Data.service_name.split(',').join(' ')
                                                    : Array.isArray(Data.service_name)
                                                        ? Data.service_name.join(' ')
                                                        : Data.service_name
                                                }
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('availability_status')} : &nbsp;
                                            </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.availability_status === 0 ? 'Not Available' : 'Available'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('experience_qualification')} : &nbsp;
                                            </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>{Data.experience_qualification}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('about_doctor')} : &nbsp;
                                            </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>
                                                {about.about_doctor ? about.about_doctor : 'NA'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h6 className="mt-2">
                                                {t('createdatetime')} : &nbsp;
                                            </h6>
                                        </div>
                                        <div className="col-lg-7">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.createtime}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </Col>

                    <Card.Body className="mt-5">
                        <Form>
                            <nav className="navbar navbar-expand-lg navbar-light navBar">
                                <div
                                    className="container mobile"
                                    id="container-div"
                                    style={{ marginTop: '-2rem', width: '22rem', borderRadius: '5px', marginLeft: '0rem' }}
                                >
                                    <button
                                        className={`btn btn-outline-success me-2 mb-2 btn-content ${content === contentTypes.appointment ? 'btn-active' : ''}`}
                                        style={{ width: '15rem' }}
                                        type="button"
                                        onClick={() => handleButtonClick('appointment')}
                                    >
                                        {t('appointment')}
                                    </button>
                                    <button
                                        className={`btn btn-outline-success me-2  mb-2 btn-content ${content === contentTypes.consultation ? 'btn-active' : ''}`}
                                        style={{ width: '15rem' }}
                                        type="button"
                                        onClick={() => handleButtonClick('consultation')}
                                    >
                                        {t('consultation')}
                                    </button>
                                    <button
                                        className={`btn btn-outline-success me-2  mb-2 btn-content ${content === contentTypes.ratings ? 'btn-active' : ''}`}
                                        style={{ width: '15rem' }}
                                        type="button"
                                        onClick={() => handleButtonClick('ratings')}
                                    >
                                        {t('ratings')}
                                    </button>
                                </div>
                            </nav>

                            {content === 0 && (
                                <div style={{ margin: '1rem' }}>
                                    <div className="mc-table-responsive">
                                        <table className="mc-table">
                                            <thead className="mc-table-head primary">
                                                <tr>
                                                    <th>
                                                        <div className="mc-table-check">
                                                            <p>{t("sno")}</p>
                                                        </div>
                                                    </th>


                                                    <th>{t("user_name")}</th>
                                                    <th>{t("clinic_name")}</th>

                                                    <th>{t("service_name")}</th>
                                                    <th>{t("status")}</th>
                                                    <th>{t("createtime")}</th>
                                                </tr>
                                            </thead>
                                            <tbody className="mc-table-body even">
                                                {appointment && appointment.length > 0 ? (
                                                    appointment.map((item, index) => (
                                                        <tr key={index}>
                                                            <td title="id">
                                                                <div className="mc-table-check">
                                                                    <p>{index + 1}</p>
                                                                </div>
                                                            </td>
                                                            <td>{item.user_name || 'NA'}</td>
                                                            <td>{item.clinic_name || 'NA'}</td>

                                                            <td>{item.service_name || 'NA'}</td>
                                                            <td>
                                                                {item.appointment_approved === 0 ? (
                                                                    <p className="pendingg">Pending</p>
                                                                ) : item.appointment_approved === 1 ? (
                                                                    <p className="approvedd">Approved</p>
                                                                ) : (
                                                                    <p className="rejectedd">Rejected</p>
                                                                )}
                                                            </td>
                                                            <td>{item.createtime || 'NA'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table >

                                    </div>
                                </div>
                            )}
                            {content === 1 && (
                                <div style={{ margin: '1rem' }}>
                                    <div className="mc-table-responsive">
                                        <table className="mc-table">
                                            <thead className="mc-table-head primary">
                                                <tr>
                                                    <th>
                                                        <div className="mc-table-check">
                                                            <p>{t("sno")}</p>
                                                        </div>
                                                    </th>


                                                    <th>{t("user_name")}</th>

                                                    <th>{t("clinic_name")}</th>
                                                    <th>{t("service_name")}</th>
                                                    <th>{t("createtime")}</th>
                                                </tr>
                                            </thead>
                                            <tbody className="mc-table-body even">
                                                {consultation && consultation.length > 0 ? (
                                                    consultation.map((item, index) => (
                                                        <tr key={index}>
                                                            <td title="id">
                                                                <div className="mc-table-check">
                                                                    <p>{index + 1}</p>
                                                                </div>
                                                            </td>
                                                            <td>{item.user_name || 'NA'}</td>
                                                            <td>{item.clinic_name || 'NA'}</td>
                                                            <td>{item.service_name || 'NA'}</td>
                                                            <td>{item.createtime || 'NA'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table >

                                    </div>
                                </div>
                            )}
                            {content === 2 && (
                                <div style={{ margin: '1rem' }}>
                                    <div className="mc-table-responsive">
                                        <table className="mc-table">
                                            <thead className="mc-table-head primary">
                                                <tr>
                                                    <th>
                                                        <div className="mc-table-check">
                                                            <p>{t("sno")}</p>
                                                        </div>
                                                    </th>


                                                    <th>{t("user_name")}</th>

                                                    <th>{t("accessibility_rating")}</th>
                                                    <th>{t("hospitality_rating")}</th>
                                                    <th>{t("cleanliness_rating")}</th>
                                                    <th>{t("treatement_quality")}</th>
                                                    <th>{t("rated_on")}</th>
                                                </tr>
                                            </thead>
                                            <tbody className="mc-table-body even">
                                                {Review && Review.length > 0 ? (
                                                    Review.map((item, index) => (
                                                        <tr key={index}>
                                                            <td title="id">
                                                                <div className="mc-table-check">
                                                                    <p>{index + 1}</p>
                                                                </div>
                                                            </td>
                                                            <td>{item.userName || 'NA'}</td>
                                                            <td>{item.accessibility_rating || 'NA'}</td>
                                                            <td>{item.hospitality_rating || 'NA'}</td>
                                                            <td>{item.cleanliness_rating || 'NA'}</td>
                                                            <td>{item.treatement_quality || 'NA'}</td>
                                                            <td>{item.createtime || 'NA'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table >

                                    </div>
                                </div>
                            )}
                        </Form>
                    </Card.Body>
                </Row>
            </div>
        </PageLayout>
    )
}